import isObject from 'lodash/isObject';
export const STASH_BRIDGE_NAME = 'stashBridge';
export const KMP_BRIDGE_NAME = 'kmpBridge';
export const KMP_JS_BRIDGE_NAME = 'kmpJsBridge';

const kmpBridgeNames = [KMP_BRIDGE_NAME, KMP_JS_BRIDGE_NAME];

export const stashPlatformConstant = {
	ANDROID: 'android',
	IOS: 'ios',
};

export const cookieNames = {
	STASH_ACCESS_TOKEN: 'stashAccessToken',
	STASH_REFRESH_TOKEN: 'stashRefreshToken',
	STASH_UUID: 'stashUUID',
	NATIVE_PLATFORM: 'nativePlatform',
	NATIVE_APP_VERSION: 'nativeAppVersion',
	NATIVE_APP_ID: 'nativeAppID',
	NATIVE_THEME: 'nativeTheme',
};

const getOSPostMessageFn = (bridgeName = STASH_BRIDGE_NAME) => {
	const kmpBridge = kmpBridgeNames
		.map((name) => window[name])
		.find((bridge) => typeof bridge?.callNative === 'function');

	if (kmpBridge) {
		// KMP WebView bridges dispatch to registered native handler names.
		return (msg) => kmpBridge.callNative(bridgeName, JSON.stringify(msg), null);
	}

	// Android Webviews
	if (window[bridgeName]) {
		const bridge = window[bridgeName].receiveMessageFromJS.bind(window[bridgeName]);
		return (msg) => bridge(JSON.stringify(msg)); // JSON string for android
	}

	// iOS Webviews
	if (window?.webkit?.messageHandlers?.[bridgeName]) {
		return window.webkit.messageHandlers[bridgeName].postMessage.bind(
			window.webkit.messageHandlers[bridgeName]
		);
	}

	return (msg) => {
		console.group(`Bridge message received`);
		console.log(msg);
		console.groupEnd();
		window.dispatchEvent(
			new CustomEvent('appetizerMessage', {
				detail: msg,
			})
		);
	};
};

const createMessageDispatcher = (bridge) => {
	return (msg) => {
		if (!msg || typeof msg.action !== 'string' || !isObject(msg.payload)) {
			throw new Error('tried sending a message with inproper format');
		}
		const stashBridgePostMessage = getOSPostMessageFn(bridge);
		return stashBridgePostMessage(msg);
	};
};

export const sendMessage = createMessageDispatcher();
